const { BASE_URL } = require("./client");

const UPLOAD_AUDIENCE = BASE_URL + '/api/admin/audience/uploadaudience';
const GET_AUDIENCE = BASE_URL + '/api/admin/audience/get';
export {
    UPLOAD_AUDIENCE,
    GET_AUDIENCE
};
